import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import FileUploaderContrato from '../components/FileUploaderContrato';

const Contrato: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Validate required URL parameters
    const params = new URLSearchParams(window.location.search);
    const requiredParams = ['token', 'contratacionId', 'returnUrl'];
    const missingParams = requiredParams.filter(param => !params.get(param));

    if (missingParams.length > 0) {
      console.error(`Missing required parameters: ${missingParams.join(', ')}`);
      // Redirect to an error page or handle the error appropriately
      navigate('/error', { 
        state: { 
          error: `Missing required parameters: ${missingParams.join(', ')}`,
          code: 'INVALID_PARAMS'
        } 
      });
      return;
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="max-w-4xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow">
          <div className="p-6">
            <FileUploaderContrato />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contrato;